import React, { memo } from "react";

const ReadyMadeFormActions = memo(function ReadyMadeFormActions({
  loading,
  submitLabel,
  submitDisabled,
  discardDraft,
}) {
  return (
    <div className="admin-form-actions admin-form-actions--sticky">
      <button
        type="submit"
        className="admin-btn admin-btn--primary"
        disabled={submitDisabled}
      >
        {loading ? "Saving..." : submitLabel}
      </button>

      <button
        type="button"
        className="admin-btn admin-btn--secondary"
        onClick={discardDraft}
        disabled={submitDisabled}
      >
        Reset form
      </button>
    </div>
  );
});

export default ReadyMadeFormActions;
